import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'

// テンプレート選択用Stimulusコントローラー
// Swiperカルーセルと連動してhidden_fieldを更新
export default class extends Controller {
  static targets = []
  private swiper: Swiper | null = null

  connect() {
    this.initializeSwiper()
    this.setupFormSubmitHandler()
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy()
    }
  }

  private initializeSwiper() {
    // Swiperの初期化
    this.swiper = new Swiper(this.element as HTMLElement, {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 100,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      effect: 'coverflow',
      coverflowEffect: {
        rotate: 0,
        scale: 0.7,
        slideShadows: false,
      },
      loop: false,
      // スライド変更時のイベント
      on: {
        slideChange: () => {
          this.updateTemplateId()
        },
        slideChangeTransitionEnd: () => {
          this.dispatchActiveSlideChanged()
        },
        init: () => {
          // 初期化時にも更新
          this.updateTemplateId()
          this.dispatchActiveSlideChanged()
        }
      }
    })

    // 初期選択を設定
    const hiddenField = document.querySelector('#template_id') as HTMLInputElement
    if (hiddenField && hiddenField.value) {
      const initialIndex = parseInt(hiddenField.value) - 1
      if (this.swiper && initialIndex >= 0) {
        this.swiper.slideTo(initialIndex, 0)
      }
    }
  }

  private updateTemplateId() {
    if (!this.swiper) return

    // 現在のスライドのtemplate-idを取得
    const activeSlide = this.swiper.slides[this.swiper.activeIndex] as HTMLElement
    const templateId = activeSlide.dataset.templateId

    if (templateId) {
      // hidden_fieldを更新 - IDで直接取得（template.html.slimのline 7で定義）
      const hiddenField = document.querySelector('#template_id') as HTMLInputElement
      if (hiddenField) {
        hiddenField.value = templateId
        console.log('Template ID updated:', templateId)
      }
    }
  }

  private dispatchActiveSlideChanged() {
    document.dispatchEvent(new CustomEvent('template:active-changed'))
  }

  private setupFormSubmitHandler() {
    // フォーム要素を取得
    const form = document.querySelector('#u-display-contents') as HTMLFormElement
    if (form) {
      form.addEventListener('submit', (e) => {
        // submit直前に最新のアクティブスライドの値を更新
        this.updateTemplateId()
      })
    }
  }
}
